import { useStaticQuery, graphql } from "gatsby";

const query = graphql`
    fragment GlobalAlertFields on DatoCmsGlobalAlert {
        __typename
        id
        iconName
        title
        text
        link {
            ...LinkBlock
        }
        startDatetime
        endDatetime
        isDismissible
        meta {
            updatedAt
        }
    }

    query GlobalAlert {
        datoCmsGlobalAlert {
            ...GlobalAlertFields
        }
    }
`;

export const useGlobalAlert = (): Queries.GlobalAlertFieldsFragment | null => {
    
    const data = useStaticQuery<Queries.GlobalAlertQuery>(query);

    return data.datoCmsGlobalAlert;
};